var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMochila(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#02404F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mochila",
    transform: "translate(4.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_90",
    className: "st0",
    d: "M10.9,0c6.3,0,11.4,5.1,11.4,11.4c0,0,0,0,0,0v13.3c0,2.9-2.3,5.2-5.2,5.2H3.9 c-2.9,0-5.2-2.3-5.2-5.2V12.2C-1.4,5.5,4.1,0,10.9,0C10.9,0,10.9,0,10.9,0z M17.1,28.2c1.9,0,3.5-1.5,3.5-3.5V11.4 c0-5.3-4.3-9.7-9.7-9.7C5.1,1.8,0.4,6.5,0.4,12.2v12.5c0,1.9,1.5,3.5,3.5,3.5H17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8,17.1H4.1c-1.3,0-2.3,1-2.3,2.3v5.5c0,1.3,1,2.3,2.3,2.3h12.7c1.3,0,2.3-1,2.3-2.3v-5.5 C19.1,18.1,18.1,17.1,16.8,17.1z M17.3,24.9c0,0.3-0.2,0.5-0.5,0.5H4.1c-0.3,0-0.5-0.2-0.5-0.5v-5.5c0-0.3,0.2-0.5,0.5-0.5h12.7 c0.3,0,0.5,0.2,0.5,0.5V24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_473",
    className: "st0",
    d: "M0,10c-0.5,0-0.9-0.4-0.9-0.9V3.6C-0.9,2.2,0.3,1,1.7,1h2C4.4,1,5,1.2,5.5,1.7 C5.9,2,5.9,2.5,5.6,2.9C5.3,3.3,4.7,3.3,4.3,3c0,0,0,0,0,0C4.2,2.8,3.9,2.8,3.7,2.7h-2c-0.5,0-0.9,0.4-0.9,0.9v5.5 C0.9,9.6,0.5,10,0,10C0,10,0,10,0,10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_474",
    className: "st0",
    d: "M21.2,10c-0.5,0-0.9-0.4-0.9-0.9V3.6c0-0.5-0.4-0.9-0.9-0.9h-2c-0.2,0-0.5,0.1-0.6,0.3 c-0.4,0.3-0.9,0.3-1.3-0.1c-0.3-0.4-0.3-0.9,0.1-1.3c0,0,0,0,0,0C16.1,1.2,16.8,1,17.5,1h2c1.5,0,2.7,1.2,2.7,2.7v5.5 C22.1,9.6,21.7,10,21.2,10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_15",
    className: "st0",
    d: "M16,10H4.9C4.4,10,4,9.6,4,9.1s0.4-0.9,0.9-0.9H16c0.5,0,0.9,0.4,0.9,0.9S16.5,10,16,10z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMochila);
export default __webpack_public_path__ + "static/media/Mochila.8a3fa55dc67b509166595d9882cf1eca.svg";
export { ForwardRef as ReactComponent };